import { render, staticRenderFns } from "./PartnerList.vue?vue&type=template&id=387445a8&scoped=true"
import script from "./PartnerList.vue?vue&type=script&lang=ts"
export * from "./PartnerList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387445a8",
  null
  
)

export default component.exports